import { useState, useEffect } from "react";
import axios from "../../AxiosInstance";
import Sidebar from "../../components/Sidebar";
import toast from "react-hot-toast";
import { FaGoogle, FaCheckCircle, FaTimesCircle, FaSave, FaInfoCircle } from "react-icons/fa";

const GoogleAnalytics = () => {
  const [measurementId, setMeasurementId] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  // Fetch current settings
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsFetching(true);
    try {
      const storedAuth = JSON.parse(localStorage.getItem("auth"));
      const token = storedAuth?.token;

      if (!token) {
        console.error("❌ Token missing in localStorage");
        setIsFetching(false);
        return;
      }

      const res = await axios.get("api/v1/admin/google-analytics/public");

      if (res.data && res.data.success) {
        const settings = res.data;
        setMeasurementId(settings.measurementId || "");

      }
    } catch (error) {
      console.error("❌ Error fetching Google Analytics settings:", error);
      // Don't show error toast on initial load if no settings exist
      if (error.response?.status !== 404) {
        toast.error("Failed to fetch Google Analytics settings");
      }
    } finally {
      setIsFetching(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!measurementId.trim()) {
      toast.error("Please enter a Measurement ID");
      return;
    }

    // Validate format
    const measurementIdPattern = /^G-[A-Z0-9]+$/;
    if (!measurementIdPattern.test(measurementId.trim())) {
      toast.error("Invalid Measurement ID format. Expected format: G-XXXXXXXXXX");
      return;
    }

    setIsLoading(true);
    try {
      const storedAuth = JSON.parse(localStorage.getItem("auth"));
      const token = storedAuth?.token;

      if (!token) {
        toast.error("Authentication required");
        setIsLoading(false);
        return;
      }

      const res = await axios.post(
        "api/v1/admin/google-analytics",
        {
          measurementId: measurementId.trim(),
          isActive:true,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data && res.data.success) {
        toast.success("Google Analytics settings saved successfully!");
        // Reload the page to apply new Google Analytics ID
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (error) {
      console.error("❌ Error updating Google Analytics settings:", error);
      toast.error(
        error.response?.data?.message ||
          "Failed to update Google Analytics settings"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">


        {/* Content */}
        <div className="flex-1 overflow-auto p-6 w-full px-4 flex justify-center items-center">
          {isFetching ? (
            <div className="flex items-center justify-center h-64">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#34c3c9]"></div>
            </div>
          ) : (
            <div className="max-w-xl mx-auto w-full">

              {/* Form Card */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Measurement ID Input */}
                  <div>
                    <label
                      htmlFor="measurementId"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Measurement ID <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        id="measurementId"
                        value={measurementId}
                        onChange={(e) => setMeasurementId(e.target.value)}
                        placeholder="G-XXXXXXXXXX"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#34c3c9] focus:border-transparent outline-none transition-all"
                        required
                      />
                      {measurementId && (
                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                          {/^G-[A-Z0-9]+$/.test(measurementId.trim()) ? (
                            <FaCheckCircle className="text-green-500" />
                          ) : (
                            <FaTimesCircle className="text-red-500" />
                          )}
                        </div>
                      )}
                    </div>
                    <p className="mt-1 text-xs text-gray-500">
                      Format: G- followed by alphanumeric characters
                    </p>
                  </div>

         

             

                  {/* Submit Button */}
                  <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={() => {
                        setMeasurementId("");
                        setIsActive(true);
                      }}
                      className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                      disabled={isLoading}
                    >
                      Reset
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading || !measurementId.trim()}
                      className="px-6 py-2 text-sm font-medium text-white bg-[#34c3c9] rounded-lg hover:bg-[#2aa8ad] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          Saving...
                        </>
                      ) : (
                        <>
                          <FaSave />
                          Save Settings
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>


            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleAnalytics;

